import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TasksTableAgence from "../../Components/TasksTableAgence";
import TasksChart from "../../Components/TasksChart";
import { useProjet } from "../../Contexts/projet";
import Typography from "@material-ui/core/Typography";
import Title from "../../Components/Title";
import { CircularProgress, Divider, withStyles } from "@material-ui/core";
import TasksTableClient from "../../Components/TasksTableClient";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    marginBottom: 20,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },
  container: {
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 400,
  },
  section: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

function DashboarProjet({isClient}) {
  const classes = useStyles();
  const {
    isLoading,
    tasks,
    workflows,
    folder,
    getTaskNumberByWorkflow,
    getTaskNumberCompleted,
    getTaskNumberActive,
  } = useProjet();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  const mois = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  const getTypoColor = (dataWorkflow) => {
    const TextTypography = withStyles({
      root: {
        color: dataWorkflow.workflow.color.toLowerCase(),
      },
    })(Typography);
    return (
      <TextTypography component="p" variant="h5">
        {dataWorkflow.count}
      </TextTypography>
    );
  };

  const getTaskNumberByWorkflowTemplate = () => {
    let res = getTaskNumberByWorkflow();
    return (
      <>
        {Object.keys(res).map((workflowName) => {
          return (
            <section className={classes.section}>
              <Typography
                color="textSecondary"
                className={classes.depositContext}
              >
                {workflowName}:
              </Typography>
              {getTypoColor(res[workflowName])}
            </section>
          );
        })}
      </>
    );
  };

  return (
    <div className={classes.root}>
      <main className={classes.content}>
        <Container maxWidth="lg" className={classes.container}>
          <Typography component="p" variant="h3" className={classes.title}>
            {folder && folder.title} : Compte rendu du mois de{" "}
            {mois[new Date().getMonth()]}
            {isLoading && <CircularProgress />}
          </Typography>
          {!isLoading && (
            <Grid container spacing={3}>
              {/* Chart */}
              <Grid item xs={12} md={7} lg={8}>
                <Paper className={fixedHeightPaper}>
                  <TasksChart />
                </Paper>
              </Grid>
              {/* Recent Deposits */}
              <Grid item xs={12} md={5} lg={4}>
                <Paper className={fixedHeightPaper}>
                  <Title>Résumé</Title>
                  <section className={classes.section}>
                    <Typography
                      color="textSecondary"
                      className={classes.depositContext}
                    >
                      Nombre de tâches actives:
                    </Typography>
                    <Typography component="p" variant="h5">
                      {tasks && workflows && getTaskNumberActive()}
                    </Typography>
                  </section>
                  <section className={classes.section}>
                    <Typography
                      color="textSecondary"
                      className={classes.depositContext}
                    >
                      Nombre de tâches terminées:
                    </Typography>
                    <Typography component="p" variant="h5">
                      {tasks && workflows && getTaskNumberCompleted()}
                    </Typography>
                  </section>
                  <section className={classes.section}>
                    <Typography
                      color="textSecondary"
                      className={classes.depositContext}
                    >
                      Nombre de tâches restantes:
                    </Typography>
                    <Typography component="p" variant="h5">
                      {tasks && workflows && ( 20 - getTaskNumberActive() - getTaskNumberCompleted()) }
                    </Typography>
                  </section>
                  <Title>Nombre de tâches actives</Title>
                  {tasks && workflows && getTaskNumberByWorkflowTemplate()}
                </Paper>
              </Grid>
              {/* Recent Orders */}
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  {isClient ? <TasksTableClient/> : <TasksTableAgence />}
                </Paper>
              </Grid>
            </Grid>
          )}
        </Container>
      </main>
    </div>
  );
}

export default DashboarProjet;
